export function materialDownload() {
  // リンククリック時に資料情報を保存する
  document.querySelectorAll('.download-btn').forEach(function(link) {
    link.addEventListener('click', function(event) {
      var materials = link.getAttribute('data-materials');
      if (materials) {
        localStorage.setItem('selectedMaterials', materials);
      }
      // ページ遷移はデフォルトのリンク動作に任せる
    });
  });

  // download ページで情報を読み取る
  var materials = localStorage.getItem('selectedMaterials');
  if (materials) {
    // 複数の資料を分割して処理
    materials.split(',').forEach(function(material) {
      // 各資料のオプション内のチェックボックスを探してチェック
      var checkboxes = document.querySelectorAll(`input[type='checkbox'][value="${material.trim()}"]`);
      checkboxes.forEach(function(checkbox) {
        checkbox.checked = true;
      });
    });

    // 使用後にlocalStorageから削除
    localStorage.removeItem('selectedMaterials');
  }
}
